import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import ActivityList from 'components/ActivityList';
import Pagination from 'components/PaginationButtons';
import Modal from 'components/Modal';

const Container = styled.div``;

const HeaderContainer = styled.div`
  margin: 38px;
  padding-bottom: 5px;
  position: relative;
  width: auto;
  position: relative;
  height: 50px;
`;

const Button = styled.button`
  border-radius: 5px;
  color: white;
  background-color: #38b6ff;
  border: 1px solid #38b6ff;
  padding: 15px 25px;
  color: #ffffff;
  cursor: pointer;
  position: absolute;
  right: 0px;
`;

const Restaurants = props => {
  const {
    currentPage,
    changePage,
    restaurantsCount,
    elementsPerPage,
    restaurants,
    isOpen,
    toggleModal,
    removeRestaurant,
    loading,
  } = props;

  return (
    <Container>
      <HeaderContainer>
        <Pagination
          currentPage={currentPage}
          changePage={changePage}
          totalPages={Math.ceil(restaurantsCount / elementsPerPage)}
        />
        <Link to="/restaurants/create">
          <Button>Create Restaurant</Button>
        </Link>
      </HeaderContainer>
      <ActivityList
        toEdit="/restaurants"
        activities={restaurants}
        onRemoveActivity={toggleModal}
        loading={loading}
      />
      <Modal
        closeIcon
        isVisible={isOpen}
        title="DELETE RESTAURANT"
        cancelText="Cancel"
        onCancel={toggleModal}
        successText="Remove"
        onSuccess={removeRestaurant}
      >
        Are you sure of remove the restaurant?
      </Modal>
    </Container>
  );
};

export default Restaurants;
